import { FC, ReactNode } from "react";

export interface LiveChatUIConversationListProps {
  title: string;
  children: ReactNode;
}

export const LiveChatUIConversationList: FC<
  LiveChatUIConversationListProps
> = ({ title, children }) => (
  <div className="flex flex-col gap-2">
    <span className="font-secondary text-dark-500 px-2 text-xs font-normal">
      {title}
    </span>
    <ul className="m-0 flex list-none flex-col gap-3 p-0">{children}</ul>
  </div>
);
